import { AxiosError, AxiosInstance, HttpStatusCode } from 'axios';
import { ApiError, ApiErrorData } from './api';

interface AxiosInterceptorOptions {
  instance: AxiosInstance;
  getAccessToken?: () => Promise<string | undefined> | string | undefined;
  onUnauthorized?: () => void;
  onForbidden?: () => void;
}

export const createAxiosInterceptor = ({
  instance,
  getAccessToken,
  onForbidden,
  onUnauthorized,
}: AxiosInterceptorOptions) => {
  const requestInterceptor = instance.interceptors.request.use(
    async (config) => {
      const token = await getAccessToken?.();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      console.log(`Axios: ${config.method?.toUpperCase()} ${config.url}`);

      return config;
    },
    (error) => Promise.reject(error),
  );

  const responseInterceptor = instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError<ApiErrorData>) => {
      if (!error.isAxiosError) return Promise.reject(error);

      if (!error.response) return Promise.reject(error);

      if (error.response.status === HttpStatusCode.Forbidden) {
        onForbidden?.();
      }

      if (error.response.status === HttpStatusCode.Unauthorized) {
        onUnauthorized?.();
      }

      return Promise.reject(new ApiError(error));
    },
  );

  return () => {
    instance.interceptors.request.eject(requestInterceptor);
    instance.interceptors.response.eject(responseInterceptor);
  };
};
